export default __webpack_public_path__ + "static/loading-95b79321d1bd85a435b35f7d8d8c0801.gif";